import Box from "ds/components/Box";
import Button from "ds/components/Button";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerFooterActions from "ds/components/Drawer/FooterActions";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCancelButton from "ds/components/DrawerNew/CancelButton";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import Typography from "ds/components/Typography";
import useCopyToClipboard from "hooks/useCopyToClipboard";
import useTypedContext from "hooks/useTypedContext";
import { getHostName } from "utils/urls";
import { AccountContext } from "views/AccountWrapper";

import styles from "./styles.module.css";
import { ProviderVersionDrawerProps } from "./types";

const code = (source: string, provider: string, version: string) =>
  `
terraform {
  required_providers {
    ${provider} = {
      source = "${source}/${provider}"
      version = "${version}"
    }
  }
}

provider "${provider}" {
  # Configuration options
}
`.trim();

const ProviderVersionDrawer = createDrawer(
  ({ provider, providerVersion }: ProviderVersionDrawerProps) => {
    const { accountName } = useTypedContext(AccountContext);
    const hostname = getHostName();

    const snippet = code(`${hostname}/${accountName}`, provider.id, providerVersion.number);

    const handleCopy = useCopyToClipboard(snippet);

    return (
      <DrawerSimple>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="How to use this provider" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody fullHeight>
          <Box>
            <Typography tag="p" variant="p-body2">
              To install this provider, copy and paste this code into your Terraform configuration.
            </Typography>
          </Box>
          <Typography tag="code" variant="s-body3" className={styles.code}>
            <pre>{snippet}</pre>
          </Typography>
          <DrawerFooter>
            <DrawerFooterActions>
              <DrawerCancelButton />
              <Button variant="secondary" onPress={handleCopy}>
                Copy
              </Button>
            </DrawerFooterActions>
          </DrawerFooter>
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showProviderVersionDrawer = createDrawerTrigger(ProviderVersionDrawer);
